<template>
    <div class="biz-setting-center parent-frame">
        <div class="biz-setting-center-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .biz-setting-center{
        position: relative;
        .biz-setting-center-wrap{
            padding-left: 30px;
            padding-right: 30px;
            width:  calc(1180px - 40px);
        }
    }
    @media screen and (max-width: 1280px){
        .biz-setting-center{
            .biz-isetting-center-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/settingCenterFrame.vue